





import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

export type TextTheme = 'red' | 'green' | 'blue' | 'yellow' | 'purple' | 'pink';

interface HighlightedText {
  text: string;
  theme: TextTheme;
}

@Component({
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class EmphasisText extends Vue {
  @Prop({ type: String, default: 'blue' }) theme!: string;
  @Prop({ type: Array, default: () => [] }) textList!: HighlightedText[];
  @Prop({ type: Number, default: 100 }) typeDelay!: number;
  @Prop({ type: Number, default: 60 }) typeSpeed!: number;
  @Prop({ type: Number, default: 1000 }) eraseDelay!: number;
  @Prop({ type: Number, default: 60 }) eraseSpeed!: number;
  @Prop({ type: Number, default: 950 }) initialDelay!: number;

  private textIndex = 0;

  private emphasisText = '';

  private get currentText(): HighlightedText {
    return this.textList[this.textIndex];
  }

  private get currentTheme(): string {
    if (this.textList.length) {
      return this.currentText.theme;
    }
    return this.theme;
  }

  private eraseTheText(): Promise<void> {
    return new Promise(resolve => {
      const deleter = setInterval(() => {
        if (this.emphasisText.length === 0) {
          clearInterval(deleter);
          resolve();
        } else {
          this.emphasisText = this.emphasisText.substring(0, this.emphasisText.length - 1);
        }
      }, this.eraseSpeed);
    });
  }

  private typeTheText(): Promise<void> {
    return new Promise(resolve => {
      const typer = setInterval(() => {
        const { text } = this.currentText;
        if (this.emphasisText.length === text.length) {
          clearInterval(typer);
          resolve();
        } else {
          this.emphasisText = text.substring(0, this.emphasisText.length + 1);
        }
      }, this.typeSpeed);
    });
  }

  private async runTypewriter(): Promise<any> {
    await this.eraseTheText();

    if (this.textIndex === this.textList.length - 1) {
      this.textIndex = 0;
    } else {
      this.textIndex += 1;
    }

    setTimeout(async () => {
      await this.typeTheText();
      setTimeout(() => this.runTypewriter(), this.eraseDelay);
    }, this.typeDelay);
  }

  private created(): void {
    if (this.textList.length) {
      this.emphasisText = this.currentText.text;
    }
  }

  private mounted(): void {
    if (this.textList.length) {
      setTimeout(() => this.runTypewriter(), this.initialDelay);
    }
  }
}
